import React, { Component } from 'react';
import GoogleMap from '../Map/Map';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import RestaurantIcon from '../../assets/img/map-icons/restaurant.svg';
import UserIcon from '../../assets/img/map-icons/user.svg';
import DriverIcon from '../../assets/img/map-icons/driver.svg';
import { getAlerts } from '../../store/actions';
import { connect } from 'react-redux';

const alertsMapping = {
    'canceled': { prop: 'canceled_order_alerts', name: 'Driver canceled the order' },
    'complains': { prop: 'user_complain_alerts', name: 'User Complains' },
    'duplication': { prop: 'order_duplication_alerts', name: 'Order Duplication' },
    'exceeds': { prop: 'exceed_threshold_alerts', name: 'Order Exceeds The Threshold' },
    'no-driver': { prop: 'no_driver_accept_alerts', name: 'No Driver Accepts The Order' }
};


const Alert = props => {
    return (
        <li className={ props.className }
            onClick={ () => props.history.push(`/operation-room/map/${props.alert}/${props.id}/${props.order}`) }>
            <p className="title">{ props.title }</p>
            <div className="info">
                <p>Order ID</p>
                <Link to="#">{ props.order }</Link>
            </div>
        </li>
    );
};


class Map extends Component {

    state = {
        drivers: null,
        cancelDialog: false,
        complainDialog: false,
        duplicationDialog: false,
        exceedDialog: false,
        noDriverDialog: false
    };

    componentDidMount() {
        this.props.getAlerts();
    }

    render() {
        let alerts = [];
        if (this.props.alerts) {
            for (const alert of this.props.alerts) {
                for (const key in alertsMapping) {
                    if(alert[alertsMapping[key].prop]) {
                        alerts.push( <Alert key={alert.id}
                                            order={alert.order}
                                            alert={ alertsMapping[key].prop }
                                            id={ alert.id }
                                            className={key}
                                            title={ alertsMapping[key].name } {...this.props}/> );
                    }
                }
            }
        }

        return (
            <React.Fragment>
                <div className="map-wrapper">

                    <div className="map">
                         <GoogleMap alerts={this.props.alerts } room position={ {latitude: 24.774265, longitude: 46.738586 } } />
                        <ul className="map-icons">
                            <li>
                                <img src={ RestaurantIcon } alt="Restaurant icon"/>
                                <span>Restaurants</span>
                            </li>
                            <li>
                                <img src={ UserIcon } alt="User icon"/>
                                <span>User</span>
                            </li>
                            <li>
                                <img src={ DriverIcon } alt="Driver icon"/>
                                <span>Driver</span>
                            </li>

                        </ul>

                    </div>
                    <div className="options-side">
                        <Scrollbars style={{ maxWidth: "100%" }} >
                            <ul className="alert-list">
                                {alerts}
                            </ul>
                        </Scrollbars>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}



const mapStateToProps = state => {
    return {
        alerts: state.operations.alerts
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAlerts: () => dispatch( getAlerts(null, 'pending') )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)( Map );



// WEBPACK FOOTER //
// ./src/components/Operation-room/Map.js